import timerReducer from './reducers';
import * as timerActions from './actions';

export { timerActions };
export default timerReducer;
